import { QueryParam } from "../store/actions";
import { format } from 'date-fns';

export const defaultIlivestockQuery: QueryParam[] = [
  { name: "businesses" },
  { name: "gifts" },
  { name: "customerOfOrganisation" },
  { name: "employeeOfOrganisation" },
];

export enum DeferredLoadingFlags {
  ILIVESTOCK_USER = "ILIVESTOCK_USER",
  BUSINESSES = "BUSINESSES",
  HOLDINGS = "HOLDINGS",
  GIFTS = "GIFTS",
  FIREBASE_SYNC_BUSINESSES = "FIREBASE_SYNC",
  SILENT_AUTH = "SILENT_AUTH",
}

export const splitPhoneNumberFromPrefix = (
  country: string,
  value?: string
): { prefix: string; number: string } => {
  if (!value)
    return {
      prefix: country,
      number: "",
    };
  return { prefix: value.slice(1, 3), number: value.slice(3, value.length) };
};

export const sanitizeUserAttributes = (attributes: any) => {
  const whiteSpaceRE = /\s+/g;

  if ("phone_number" in attributes) {
    attributes.phone_number = attributes.phone_number.replace(whiteSpaceRE, "");
  }
  if ("phoneNumber" in attributes) {
    attributes.phoneNumber = attributes.phoneNumber.replace(whiteSpaceRE, "");
  }
  if ("email" in attributes) {
    attributes.email = (attributes.email || "").toLowerCase();
  }

  return attributes;
};

/*
 * Format date in to human friendly format
 * @param date - timestamp in milliseconds or a Date object
 * @returns string
 */
export const formatDate = (date: number|Date): string => {
  return format(new Date(date), "MMM do yyyy")
}
